import { useQuery } from '@tanstack/react-query'

import type { Microservice } from '../../types/microservices'
import api from '../../api'

const useSingleMicroservice = (microserviceID: string) => {
	return useQuery({
		queryKey: ['microservices', microserviceID],
		queryFn: () =>
			api.microservices.getSingleMicroservice(microserviceID),
		select(data) {
			if (data.body !== undefined) {
				const response = sortComments(data.body[0])
				return response as Microservice
			} else {
				let response = {} as Microservice
				response['status'] = 'ERROR'
				response['details'] = data
				return response
			}
		}
	})
}
const sortComments = (response: Record<any, any>) => {
	let sortedCommentResponse = JSON.parse(JSON.stringify(response))
	let comments = (response && response.comments) || []
	sortedCommentResponse['comments'] = comments.sort(
		(a: any, b: any) =>
			new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
	)
	return sortedCommentResponse
}

export default useSingleMicroservice
